// extracted by mini-css-extract-plugin
export default {"meter":"AKPJP5sstMvPNhnAtQHr","suboptimum":"eVAlxv4PHO5D2X8drSyt","evenLessGood":"_oRhcCI1pgLrlv_WmXzP"};